var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return (_vm.activated || _vm.isActivated) && _vm.entry
    ? _c(
        "div",
        {
          ref: "detailsContainer",
          class: {
            "detail-scroll-container": true,
            "details-preview": _vm.previewMode
          },
          on: { click: _vm.leavePreviewMode }
        },
        [
          _c(
            "div",
            { staticClass: "detail-container" },
            [
              _c(
                "SimpleBar",
                { attrs: { horizontal: false, vertical: !_vm.previewMode } },
                [
                  _c("div", { staticClass: "detail-header" }, [
                    _c(
                      "a",
                      { attrs: { href: "#" }, on: { click: _vm.onClose } },
                      [
                        _c("img", {
                          attrs: { src: "images/arrow_back.svg", alt: "" }
                        }),
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.i18n.detailsView.mobileBackButton) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "detail-content" }, [
                    _c("div", { staticClass: "grid-layout detail-main-info" }, [
                      _c("div", { staticClass: "detail-name" }, [
                        _c("h2", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.entry.address.name) +
                              "\n\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _vm.entry.address.nameAddon2
                          ? _c("p", { staticClass: "lead" }, [
                              _vm._v(_vm._s(_vm.entry.address.nameAddon2))
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "detail-close" }, [
                        _c(
                          "a",
                          { attrs: { href: "#" }, on: { click: _vm.onClose } },
                          [
                            _c("img", {
                              attrs: {
                                src: "images/close.svg",
                                alt: _vm.i18n.detailsView.desktopCloseAltText
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "detail-address" }, [
                        _c("address", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.entry.address.streetNo) +
                              "\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.entry.address.zip) +
                              " " +
                              _vm._s(_vm.entry.address.city) +
                              "\n\t\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _vm.isNonPublic()
                          ? _c("div", { staticClass: "detail-info" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("error")
                              ]),
                              _vm._v(
                                "\n\t\t\t\t\t\t\tNicht öffentlich zugänglich\n\t\t\t\t\t\t"
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.previewMode && _vm.distance() > Number.EPSILON
                        ? _c(
                            "div",
                            { staticClass: "detail-preview-addition" },
                            [
                              _c("div", { staticClass: "detail-distance" }, [
                                _vm._v(
                                  _vm._s(_vm.$formatNumber(_vm.distance())) +
                                    " " +
                                    _vm._s(_vm.distanceUnit())
                                )
                              ]),
                              _vm._v(" "),
                              _vm.canHaveRouting()
                                ? _c(
                                    "div",
                                    { staticClass: "detail-route-link" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "routing",
                                          attrs: { href: "#" },
                                          on: { click: _vm.onOpenRouting }
                                        },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("directions")]
                                          ),
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.i18n.detailsView
                                                  .routingShort
                                              ) +
                                              "\n\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.hasTextBusinessHours() || _vm.hasBusinessHours()
                      ? _c("div", { staticClass: "detail-opening-times" }, [
                          _vm.hasTextBusinessHours()
                            ? _c("div", [
                                _c("h4", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.i18n.detailsView.businessHours
                                        .openingHours[0]
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.decodeHTML(
                                        _vm.entry.businessHours.text
                                      )
                                    )
                                  }
                                })
                              ])
                            : _vm.hasBusinessHours()
                            ? _c(
                                "div",
                                _vm._l(_vm.entry.businessHours.openAt, function(
                                  openingHours,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: `business-hours-${_vm.entry.idDecoded}-${index}`
                                    },
                                    [
                                      _c("h4", [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.i18n.detailsView.businessHours
                                                .openingHours[index]
                                            ) +
                                            "\n\t\t\t\t\t\t\t"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.openDays(openingHours, index),
                                        function(openTimes) {
                                          return _c(
                                            "div",
                                            {
                                              key: openTimes.id,
                                              class: _vm.highlightToday(
                                                "grid-layout daily-opening-time",
                                                openTimes,
                                                openingHours
                                              )
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "week-day" },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.i18n.detailsView
                                                          .businessHours.days[
                                                          openTimes.day
                                                        ]
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "times" },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        openTimes.times
                                                          .map(
                                                            ({ from, until }) =>
                                                              `${_vm.formatTime(
                                                                from
                                                              )} - ${_vm.formatTime(
                                                                until
                                                              )}`
                                                          )
                                                          .join(" und ")
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.config.detailsView.contact.enabled &&
                    _vm.hasDefaultContact()
                      ? _c("div", { staticClass: "detail-contact" }, [
                          _c("h4", [
                            _vm._v(_vm._s(_vm.i18n.detailsView.contact.title))
                          ]),
                          _vm._v(" "),
                          _vm.config.detailsView.contact.tel &&
                          _vm.entry.contact.tel.length
                            ? _c(
                                "div",
                                _vm._l(_vm.entry.contact.tel, function(
                                  tel,
                                  index
                                ) {
                                  return _c("p", { key: `tel-${index}` }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.i18n.detailsView.contact.tel
                                        ) +
                                        ":\n\t\t\t\t\t\t\t"
                                    ),
                                    _c("a", { attrs: { href: `tel:${tel}` } }, [
                                      _vm._v(_vm._s(tel))
                                    ])
                                  ])
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.config.detailsView.contact.mobile &&
                          _vm.entry.contact.mobile.length
                            ? _c(
                                "div",
                                _vm._l(_vm.entry.contact.mobile, function(
                                  mobile,
                                  index
                                ) {
                                  return _c("p", { key: `mobile-${index}` }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.i18n.detailsView.contact.mobile
                                        ) +
                                        ":\n\t\t\t\t\t\t\t"
                                    ),
                                    _c(
                                      "a",
                                      { attrs: { href: `tel:${mobile}` } },
                                      [_vm._v(_vm._s(mobile))]
                                    )
                                  ])
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.config.detailsView.contact.fax &&
                          _vm.entry.contact.fax.length
                            ? _c(
                                "div",
                                _vm._l(_vm.entry.contact.fax, function(
                                  fax,
                                  index
                                ) {
                                  return _c("p", { key: `fax-${index}` }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.i18n.detailsView.contact.fax
                                        ) +
                                        ": " +
                                        _vm._s(fax) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ])
                                }),
                                0
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.config.detailsView.contact.additionalContact &&
                    _vm.hasAdditionalContact
                      ? _c("div", { staticClass: "detail-contact" }, [
                          _vm.config.detailsView.contact.email &&
                          _vm.entry.contact.email.length
                            ? _c(
                                "div",
                                _vm._l(_vm.entry.contact.email, function(
                                  email,
                                  index
                                ) {
                                  return _c("p", { key: `email-${index}` }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.i18n.detailsView.contact.email
                                        ) +
                                        ":\n\t\t\t\t\t\t\t"
                                    ),
                                    _c(
                                      "a",
                                      { attrs: { href: `mailto:${email}` } },
                                      [_vm._v(_vm._s(email))]
                                    )
                                  ])
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.config.detailsView.contact.url &&
                          _vm.entry.contact.url.length
                            ? _c(
                                "div",
                                _vm._l(_vm.entry.contact.url, function(
                                  url,
                                  index
                                ) {
                                  return _c("p", { key: `url-${index}` }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.i18n.detailsView.contact.url
                                        ) +
                                        ":\n\t\t\t\t\t\t\t"
                                    ),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            url + "?id=" + _vm.entry.customerId,
                                          target: "_blank"
                                        }
                                      },
                                      [_vm._v(_vm._s(url))]
                                    )
                                  ])
                                }),
                                0
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasFeatures()
                      ? _c("div", { staticClass: "detail-interaction" }, [
                          _vm.canHaveAppointment
                            ? _c("div", { staticClass: "col-50" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "make-vcard",
                                    attrs: {
                                      href: _vm.vcardLink(),
                                      target: _vm.vcardLinkTarget(),
                                      download: _vm.vcardDownloadName()
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("person_add")
                                    ]),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.i18n.detailsView.vcard) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canHaveRouting()
                            ? _c("div", { staticClass: "col-50" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "routing",
                                    attrs: { href: "#" },
                                    on: { click: _vm.onOpenRouting }
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("directions")
                                    ]),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.i18n.detailsView.routing) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e()
                        ])
                      : _vm._e()
                  ])
                ]
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }